// extracted by mini-css-extract-plugin
export var announcementItemWrapper = "AnnouncementItem-module--announcementItemWrapper--2HTT0";
export var announcementItem = "AnnouncementItem-module--announcementItem--3xKUv";
export var superScript = "AnnouncementItem-module--superScript--FCdv6";
export var title = "AnnouncementItem-module--title--hlMDJ";
export var button = "AnnouncementItem-module--button--7gUIA";